export default "__VITE_ASSET__zh3vORX$__"